export const PUMA_APP_ID = 'c4a35ba2-5126-43f1-852d-dd1a098cfefd';
export const PUMA_MODULE_NAME = "DOLPHIN_DEPART";